import { render, staticRenderFns } from "./FormMultimarca.vue?vue&type=template&id=4fc0aa6f&scoped=true&"
import script from "./FormMultimarca.vue?vue&type=script&lang=js&"
export * from "./FormMultimarca.vue?vue&type=script&lang=js&"
import style0 from "./FormMultimarca.vue?vue&type=style&index=0&id=4fc0aa6f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc0aa6f",
  null
  
)

export default component.exports